import script from "./Login.vue?vue&type=script&setup=true&lang=ts"
export * from "./Login.vue?vue&type=script&setup=true&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=69b4a89d&scoped=true&lang=scss"

import exportComponent from "E:\\work\\EEEEE\\okpay\\ipay-imi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69b4a89d"]])

export default __exports__